import * as React from 'react';
import {
    BanIcon,
    BodyLargeEmphasized,
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    CircleMinusIcon,
    KeyboardCompatibleBottomSheet,
    YStack,
} from 'smoothie';

interface BillDetailsRemoveSheetProps {
    header: string;
    title: string;
    subText: string;
    editMode: boolean;
    onExclude: () => void;
    onDismiss: () => void;
}

const BillDetailsRemoveBillSheet = ({
    header,
    title,
    subText,
    editMode,
    onExclude,
    onDismiss,
}: BillDetailsRemoveSheetProps) => {
    return (
        <KeyboardCompatibleBottomSheet
            onDismiss={onDismiss}
            isInsideModal
            title={header}
            showCloseButton
        >
            <YStack gap={20}>
                <YStack gap={8}>
                    <BodyLargeEmphasized>{title}</BodyLargeEmphasized>
                    <BodyMediumRegular color="$gray1000">
                        {subText}
                    </BodyMediumRegular>
                </YStack>
                <YStack gap={8}>
                    <Button
                        variant={ButtonVariant.TERTIARY}
                        size={ButtonSize.LARGE}
                        text={editMode ? 'Keep' : 'Edit'}
                        onPress={onDismiss}
                    />
                    <Button
                        variant={ButtonVariant.PRIMARY}
                        tone="danger"
                        size={ButtonSize.LARGE}
                        text={editMode ? 'Exclude' : 'Remove'}
                        icon={editMode ? BanIcon : CircleMinusIcon}
                        onPress={onExclude}
                    />
                </YStack>
            </YStack>
        </KeyboardCompatibleBottomSheet>
    );
};

export default BillDetailsRemoveBillSheet;
